export const Bio = {
  name: "Pawan Gupta",
  roles: ["Full Stack Developer", "Programmer"],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/pawan-exe",
  resume: "",
  linkedin: "https://www.linkedin.com/in/pawangupta01/",
  twitter: "https://twitter.com/pawanzx01",
  insta: "https://www.instagram.com/_pawan_zx.03",
  facebook:
    "https://www.facebook.com/profile.php?id=100028529587290&mibextid=ZbWKwL",
};

export const skills = [
  {
    title: "Languages",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Javascript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },

      {
        name: "Typescript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Typescript_logo_2020.svg/768px-Typescript_logo_2020.svg.png",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
    ],
  },

  {
    title: "Frameworks/Libraries",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },

      {
        name: "Next JS",
        image: "https://i.imgur.com/FAkcbZO.png",
      },

      // {
      //   name: "Bootstrap",
      //   image:
      //     "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      // },
      {
        name: "Tailwind CSS",
        image: "https://i.imgur.com/EIEDYRV.png",
      },

      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },

  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },

      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
      {
        name: "Firebase",
        image: "https://i.imgur.com/uEWgiVD.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://i.imgur.com/BcAaeMP.jpg",
    role: "Software Developer Intern",
    company: "Asterisc Technocrat Pvt. Ltd.",
    date: "July 2024 - Jan 2025",
    desc: "Designed and developed responsive user interfaces using React.js, creating smooth and interactive experiences with the help of Hooks and state management. Focused on building reusable components to keep the codebase clean and consistent. Worked closely with backend teams to integrate APIs and ensure seamless communication between systems.",
    skills: ["React JS", "Javascript", "Tailwind CSS", "HTML", "CSS"],
    doc: "./asterisc.jpg",
  },
  {
    id: 1,
    img: "https://i.imgur.com/emv73Yb.jpg",
    role: "Front-end Developer Intern",
    company: "1Stop.ai",
    date: "Aug 2023 - Sept 2023",
    desc: "Work closely with diverse teams to brainstorm, design, and develop engaging websites that reflect our brand. Write clean, efficient, and maintainable code using HTML, CSS, JavaScript, and Bootstrap to turn creative designs into functional and visually appealing web experiences.",
    skills: ["Javascript", "HTML", "CSS", "Bootstrap"],
    doc: "https://i.imgur.com/7R8AmWS.jpg",
  },
];

export const education = [
  {
    id: 0,
    img: "https://i.imgur.com/1O3U1YD.jpg",
    school: "Atma Malik Institute of Technology and Research, Thane",
    date: "2021 - 2025",
    grade: "7.74 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Engineering at Atma Malik Institute of Technology and Research, Thane. I have completed 7 semesters and have a CGPA of 7.74. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, Software Engineering, and Computer Networks, among others.",
    degree: "Bachelor of Engineering - BE, Computer Engineering",
  },
  {
    id: 1,
    img: "https://i.imgur.com/LybmrJf.jpg",
    school: "National Jr College Of Science & Commerce, Kudus",
    date: "2020 - 2021",
    grade: "91.83%",
    desc: "I completed my class 12 high school education at National Jr College Of Science & Commerce, where I studied Science with IT.",
    degree: "HSC(XII), Science with IT",
  },
  {
    id: 2,
    img: "https://i.imgur.com/WazNChn.jpg",
    school: "National English School, Kudus",
    date: "2018 - 2019",
    grade: "84.20%",
    desc: "I completed my class 10 education at National English School, where I studied Science, Mathematics, and Information Technology.",
    degree: "SSC(X)",
  },
];

export const projects = [
  {
    id: 0,
    title: "FinGenix",
    date: "Dec 2024 - Jan 2025",
    description:
      "Built an AI-powered finance platform using Next.js, Supabase, and Inngest with automated reports, budget alerts, expense visualizations, and receipt scanning via Gemini AI.",
    image: "fingenix.png",
    tags: ["Next JS", "Prisma", "Supabase", "Gemini AI", "Shadcn UI"],
    category: "web app",
    github: "https://github.com/pawan-exe/FinGenix",
    webapp: "https://fin-genix.vercel.app/",
  },
  {
    id: 1,
    title: "EduXplore",
    date: "Oct 2024 - Nov 2024",
    description:
      "Created a feature-rich e-learning platform with separate views for instructors and students, offering curriculum management, course filtering, progress tracking, and a secure PayPal checkout. Integrated JWT authentication and Cloudinary for secure access and efficient video content management.",
    image: "https://i.imgur.com/gcWFAbX.png",
    tags: ["React JS", "Tailwind CSS", "Node JS", "Express JS", "MongoDB"],
    category: "web app",
    github: "https://github.com/pawan-exe/EduXplore",
    webapp: "https://eduxplore.onrender.com/",
  },
  {
    id: 2,
    title: "Threads Clone",
    date: "June 2024 - July 2024",
    description:
      "Developed a Threads Clone, a full-stack social media app with features including user authentication, post creation and deletion, liking and commenting on posts, following users, account freezing, dark/light mode, responsive design, chat with image support, seen/unseen message status, and notification sounds.",
    image: "https://i.imgur.com/F2FGjlX.png",
    tags: ["MERN Stack", "Tailwind CSS", "Chakra UI", "Socket.io"],
    category: "web app",
    github: "https://github.com/pawan-exe/Threads-Clone_",
    webapp: "https://threads-clone-wsmh.onrender.com/",
  },
  {
    id: 3,
    title: "Jobsey Portal",
    date: "Apr 2024 - June 2024",
    description:
      "Developed Jobsey, a full-stack job portal using Next.js, featuring user authentication with Clerk, recruiter and candidate roles, application management, activity status tracking, subscription plans, job filtering, feed posts, profile management, light/dark mode, and a fully responsive design.",
    image: "https://i.imgur.com/PaI1YW6.png",
    tags: [
      "Next JS",
      "React JS",
      "Tailwind CSS",
      "MongoDB",
      "Clerk",
      "Shadcn UI",
      "Stripe",
    ],
    category: "web app",
    github: "https://github.com/pawan-exe/Jobsey",
    webapp: "https://jobsey-five.vercel.app/",
  },
  {
    id: 4,
    title: "AI Interview Mocker",
    date: "Aug 2024",
    description:
      "I created an AI-driven mock interview platform utilizing Next.js, React.js, Clerk for secure authentication, Drizzle ORM with PostgreSQL, styled with Tailwind CSS, integrated with Gemini AI, and built with Shadcn UI for a seamless user experience.",
    image: "https://i.imgur.com/dkJzKpB.png",
    tags: ["Next Js", "React JS", "Drizzle ORM", "Gemini AI", "Tailwind CSS"],
    category: "web app",
    github: "https://github.com/pawan-exe/AI-Interview-Mocker",
    webapp: "https://ai-interview-mocker-psi.vercel.app/",
  },
  {
    id: 5,
    title: "TripGenie",
    date: "Oct 2024",
    description:
      "TripGenie is an AI-powered travel planner app that I built using React Native. It uses the Gemini API to offer personalized trip suggestions, like flights, hotels, and itineraries. I also integrated Firebase for secure authentication and Firestore for real-time data storage.",
    image: "https://i.imgur.com/it9Elj8.jpg",
    tags: ["React Native", "Firebase", "Gemini AI"],
    category: "mobile app",
    github: "https://github.com/pawan-exe/TripGenie-Mobile-app",
    webapp: "",
  },

  {
    id: 6,
    title: "NutriBoost - A Beverages Hub",
    date: "Nov 2023 - Jan 2024",
    description:
      "Developed NutriBoost, a MERN stack e-commerce site offering a variety of beverages, featuring user accounts, product management, advanced search filters, and Payment integration for a seamless shopping experience.",
    image: "https://i.imgur.com/3wKDuUi.png",
    tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Bootstrap"],
    category: "web app",
    github: "https://github.com/pawan-exe/NutriBoost-Ecommerce-MERN",
    webapp: "https://nutriboost-beverages.onrender.com/",
    member: [
      {
        name: "Pawan Gupta",
        img: "https://i.imgur.com/XCl8I8D.jpg",
        linkedin: "https://www.linkedin.com/in/pawankumar-gupta-59a61b247/",
        github: "https://github.com/pawan-exe",
      },
      {
        name: "Karan Joshi",
        img: "https://i.imgur.com/zL8PJwu.jpg",
        linkedin: "https://www.linkedin.com/in/karan-joshi-8756a8247/",
        github: "",
      },
      {
        name: "Shivam Gupta",
        img: "https://i.imgur.com/xvWXblt.jpg",
        linkedin: "https://www.linkedin.com/in/shivam-gupta-697727201/",
        github: "",
      },
    ],
  },
  // {
  //   id: 7,
  //   title: "Pawan's Blog",
  //   date: "Feb 2024 - March 2024",
  //   description:
  //     "Created Pawan's Blog, a web app for exploring tech topics, featuring user authentication, a secure admin dashboard, advanced search, responsive design, and dark mode.",
  //   image: "https://i.imgur.com/eJ7kj2W.png",
  //   tags: [
  //     "React Js",
  //     "Redux",
  //     "Tailwind CSS",
  //     "Node JS",
  //     "Express JS",
  //     "MongoDB",
  //   ],
  //   category: "web app",
  //   github: "https://github.com/pawan-exe/MERN-Blog-App",
  //   webapp: "https://mern-blog-website-z6u9.onrender.com/",
  // },
];
